export default "__VITE_ASSET__92_Fvkg6__"